import React, { useState, useCallback } from "react";
import { toast } from "../material/ToastPopup";
import { CloseIcon, SparkleIcon, CopyIcon, LightningIcon } from "./aiWriteIcons";
import styles from "./AiWrite.module.scss";

const MAX_LENGTH = 700;

const ResultStep = ({
    text = "",
    remainCount = 0,
    onRegenerate = () => {},
    onApply = () => {},
    onClose = () => {},
}) => {
    const [editedText, setEditedText] = useState(text);

    const handleTextChange = useCallback((e) => {
        const value = e.target.value;
        if (value.length <= MAX_LENGTH) {
            setEditedText(value);
        }
    }, []);

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(editedText).then(() => {
            toast.success("매물 설명이 복사되었습니다.");
        }).catch(() => {
            const textarea = document.createElement("textarea");
            textarea.value = editedText;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            toast.success("매물 설명이 복사되었습니다.");
        });
    }, [editedText]);

    const handleApply = useCallback(() => {
        onApply(editedText);
    }, [editedText, onApply]);

    return (
        <div className={styles.resultStep}>
            <div className={styles.settingHeader}>
                <h2 className={styles.settingTitle}>AI 매물 글쓰기</h2>
                <button className={styles.closeBtn} onClick={onClose}>
                    <CloseIcon />
                </button>
            </div>

            <div className={styles.resultBody}>
                <p className={styles.resultGuide}>디스코 AI가 생성한 글을 자유롭게 수정해보세요!</p>

                <div className={styles.resultTextArea}>
                    <textarea
                        value={editedText}
                        onChange={handleTextChange}
                        maxLength={MAX_LENGTH}
                    />
                    <div className={styles.charCount}>
                        {editedText.length}/{MAX_LENGTH}자
                    </div>
                </div>

                <div className={styles.resultActions}>
                    <button className={styles.copyBtn} onClick={handleCopy}>
                        <CopyIcon />
                    </button>
                    <button
                        className={`${styles.regenerateBtn} ${remainCount <= 0 ? styles.disabled : ""}`}
                        onClick={onRegenerate}
                        disabled={remainCount <= 0}
                    >
                        <SparkleIcon />
                        <span>다시 생성하기 ({remainCount}회 남음)</span>
                    </button>
                </div>
            </div>

            <div className={styles.settingFooter}>
                <button className={styles.applyBtn} onClick={handleApply}>
                    <LightningIcon />
                    <span>적용하기</span>
                </button>
            </div>
        </div>
    );
};

export default ResultStep;
